import { getV1, getGFT } from '@/common/utils/ajax'

const getStuckComments = (building_id) => getV1(`buildings/${building_id}/stuck_comments`)

export const getAroundFacilityRatings = building_id => getGFT(`v1/buildings/${building_id}/around_facility_ratings`)

export default {
    getStuckComments
}
